import { ActionTree } from 'vuex';
import { ProfileState, UserCredentials } from '@/store/profile/types';
import { RootState } from '@/store/types';
import { usersApi } from '@/utils/config';
import Axios from 'axios';

function createFormDataFrom(data = {}) {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'string' || value instanceof Blob) {
      formData.append(key, value);
    }

    if (typeof value === 'object') {
      formData.append(key, JSON.stringify(value));
    }
  });

  return formData;
}

const actions: ActionTree<ProfileState, RootState> = {
  async authGoogle({ commit }, payload: any) {
    try {
      const { data } = await Axios.post(usersApi.gauth, {
        user: payload,
      });
      if (data?.resp?.session) {
        localStorage.setItem('formData', '');
        localStorage.setItem('authToken', data.resp.session.token);
        commit('setSession', data.resp.session);
      }
    } catch (e) {
      const { error } = e.response?.data;
      if (error) {
        throw new Error(error);
      }
      throw e;
    }
  },
  async auth({ commit }, payload: UserCredentials) {
    try {
      const { data } = await Axios.post(usersApi.auth, {
        user: {
          email: payload.login,
          password: payload.password,
        },
      });
      if (data?.resp?.session) {
        localStorage.setItem('formData', '');
        localStorage.setItem('authToken', data.resp.session.token);
        commit('setSession', data.resp.session);
      }
    } catch (e) {
      const { error } = e.response?.data;
      if (error) {
        throw new Error(error);
      }
      throw e;
    }
  },
  async getSession({ commit, state }): Promise<any> {
    if (state.session) {
      return state.session;
    }
    let response = null;
    try {
      response = await Axios.get(usersApi.me);
    } catch (e) {
      console.error(e);
    }
    if (response?.data?.resp?.session) {
      localStorage.setItem('authToken', response.data.resp.session.token);
      commit('setSession', response.data.resp.session);
    }
    return state.session;
  },
  async logout({ commit }): Promise<void> {
    await Axios.get(usersApi.logout);
    localStorage.removeItem('authToken');
    commit('logout');
  },
  // for development purposes
  async setTempRole({ commit, state }, role): Promise<void> {
    const currentSession = state?.session;
    if (currentSession?.user_pimcore?.role?.role_type) {
      currentSession.user_pimcore.role = role;
    }
    commit('setSession', currentSession);
  },
  async sendEditedInfo(context, editedInfo: Record<string, any>) {
    const formData = createFormDataFrom(editedInfo);
    try {
      const { data } = await Axios.post(usersApi.editInfo, formData, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },
};

export default actions;
